import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import SelectField from "vino/core/forms/Select";

const TopTollBar = () => {
	return (
		<>
			<div className="flex">
				<div className="w-160"></div>
				<div className="top-views flex flex-1 w-full justify-between align-items-center px-10">
					<div className="top-items">
						{/* <div className="top-counts">
							<span className="page-count">1-24</span>
							<span className="fillets">of</span>
							<span className="total-count">6076</span>
							<span className="fillets">result</span>
						</div> */}
					</div>
					{/* <div className="top-items ipnWrap">
						<div className="drop-item perCount"></div>
						<div className="drop-item sort w-200">
							<SelectField
								label="Sort by"
								name="sortBy"
								variant="outlined"
								fullWidth
							>
								<MenuItem value="name">Name</MenuItem>
								<MenuItem value="priceAsc">Price: Low to High</MenuItem>
								<MenuItem value="priceDesc">Price: High to Low</MenuItem>
							</SelectField>
						</div>
					</div> */}
				</div>
			</div>
			<Divider className="my-5" />
		</>
	);
};

export default TopTollBar;
